module.exports = __webpack_public_path__ + "img/2.d7075815.png";